<template>
	<b-modal
		id="renamemodal1"
		size="md"
		centered
		hide-footer
		hide-header
		v-model="showresumerename"
		@hidden="showresumerename = false"
	>
		<div class="d-flex">
			<div class="w-100">
				<div class="candash-modal-body-3 p-3">
					<div class="rpro-flex-1">
						<div>
							<img
								class="rpro-svg-size"
								src="@/assets/newdesign/dashboard/creaNewPro.svg"
								alt=""
							/>
						</div>
						<div class="rpro-w95 rpro-text pl-3">
							<div class="d-flex align-items-center justify-content-between">
								<div class="candash-modal-head rpro-txt-center">
									Rename <span>Profile</span>
								</div>
								<div id="hideinmobile" class="pointer">
									<img
										@click="(loading = false), $bvModal.hide('renamemodal1')"
										class="rotate-on-hover"
										src="@/assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="candash-blackTxt mt-3">Profile Name</div>
							<div class="w95 mt-2 position-relative">
								<b-form-input
									placeholder="Enter name of the resume"
									type="text"
									:class="{
										error: $v.resumeNameNew1.$error,
									}"
									class="laptopinput"
									v-model="$v.resumeNameNew1.$model"
								></b-form-input>

								<div
									v-if="$v.resumeNameNew1.$dirty && !$v.resumeNameNew1.required"
									class="candash-errortxt errortxt-pos"
								>
									Required
								</div>
								<div
									v-if="
										!$v.resumeNameNew1.maxLength && $v.resumeNameNew1.required
									"
									class="candash-errortxt errortxt-pos"
								>
									Required
								</div>
							</div>
						</div>
					</div>
					<div class="mt-3">
						<div class="candash-light-txt-2 ml-1">
							Would you like to set this Profile as your Primary Profile?
						</div>
						<div
							class="d-flex align-items-center candash-light-txt-3 ml-1 mt-2 lh-25"
						>
							<b-form-group v-slot="{ ariaDescribedby }">
								<b-form-radio-group
									id="radio-group-1"
									v-model="selectedPrimaryOption"
									:options="isPrimaryoptions"
									:aria-describedby="ariaDescribedby"
									name="radio-options"
									:class="
										$v.selectedPrimaryOption.$error
											? 'pad-radio-red'
											: 'pad-radio'
									"
								></b-form-radio-group>
							</b-form-group>
						</div>
					</div>
				</div>
				<div
					class="p-3 d-flex align-items-center rpro-justify-cont rpro-border-top"
				>
					<b-button
						class="candash-cancelBtn mr-4 pointer rpro-40"
						@click="(loading = false), $bvModal.hide('renamemodal1')"
						>Cancel</b-button
					>

					<div class="position-relative rpro-40">
						<b-button
							:style="
								buttonLoader
									? !isLaptop
										? 'width: 100%;height: 32px;opacity:0.5'
										: 'width: 96px;height: 32px;opacity:0.5'
									: ''
							"
							class="candash-customBtn-vr pointer rpro-100 width96px"
							@click="renameResume1()"
						>
							{{ buttonLoader ? "" : "Save" }}
						</b-button>
						<div v-if="buttonLoader" class="loader-pos-new">
							<Loader />
						</div>
					</div>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
import Loader from "@/components/fixedcomponents/Loader.vue";
import { getCandidateDetail } from "@/controllers/dashboard/asynchronous";
import { required, maxLength } from "vuelidate/lib/validators";
import {
	renameResume,
	setPrimaryProfile,
	getAllProfiles,
	getCandidatePrimaryProfile,
	getProfileCompletion,
} from "@/utils/apiFunctions";
import { mapGetters } from "vuex";
import successModal from "@/components/mixin/toast";
import errorModal from "@/components/mixin/toast";
export default {
	components: {
		Loader,
	},
	data() {
		return {
			resumeNameNew1: "",
			isPrimaryoptions: [
				{ text: "Yes", value: true },
				{ text: "No", value: false },
			],
			selectedPrimaryOption: null,
			resclinicRenamed: false,
			localCandidateInfo: {},
			buttonLoader: false,
			allProfiles: [],
			isLaptop: true,
		};
	},
	mixins: [errorModal, successModal],
	validations: {
		resumeNameNew1: {
			required,
			maxLength: maxLength(20),
		},
		selectedPrimaryOption: {
			required,
		},
	},
	mounted() {
		this.checkScreenSize();
		window.addEventListener("resize", this.checkScreenSize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.checkScreenSize);
	},
	computed: {
		...mapGetters("candidateVUEX", {
			getcandidateInfo: "getcandidateInfo",
		}),
	},
	props: {
		showresumerename: {
			type: Boolean,
		},
	},
	methods: {
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
			this.isTablet = window.innerWidth >= 600 && window.innerWidth < 1024;
		},
		async renameResume1() {
			this.$v.$touch();
			if (!this.$v.resumeNameNew1.$invalid) {
				this.buttonLoader = true;
				try {
					const res = await renameResume({
						_id: this.getcandidateInfo._id,
						profileName: this.resumeNameNew1,
					});

					if (res.status === 200) {
						this.buttonLoader = true;
						this.localCandidateInfo = await getCandidateDetail(this);
						if (this.selectedPrimaryOption) {
							let payload = { id: this.getcandidateInfo._id };
							const response = await setPrimaryProfile(payload);
							if (response.status === 200) {
								this.getAllProfiles();
								const res2 = await getCandidatePrimaryProfile();
								if (res2.status === 200) {
									this.$store.commit(
										"candidateVUEX/setPrimaryProfile",
										res2.data.data
									);

									this.localCandidateInfo = await getCandidateDetail(this);
									this.$store.commit(
										"candidateVUEX/setCandidateInfo",
										this.localCandidateInfo
									);
								}

								const respData = await getProfileCompletion(
									this.getcandidateInfo._id
								);
								const candProgressPrimaryResp = respData.data.data;
								this.$store.commit(
									"candidateVUEX/updateCandidateProgressPrimary",
									candProgressPrimaryResp
								);
								this.$store.commit("candidateVUEX/setResclinicRename", true);
							} else if (res.status === 409) {
								this.buttonLoader = false;
								return this.errorModal(
									"Error",
									"Resume with same name exists!"
								);
							} else {
								this.errorModal("Error", "Something went wrong!");
								this.buttonLoader = false;
							}
						}

						this.$store.commit(
							"candidateVUEX/setCandidateInfo",
							this.localCandidateInfo
						);
						this.buttonLoader = false;
						this.$store.commit("candidateVUEX/setResclinicRename", true);
						this.showresumerename = false;
						this.$bvModal.hide("renamemodal1");
						this.$nextTick(() => {
							this.successModal(
								"Successfully renamed",
								"Profile Name has been renamed"
							);
						});
					}
				} catch (error) {
					this.buttonLoader = false;
					this.errorModal("Error", "Something went wrong!");
				}
			}
		},
		async getAllProfiles() {
			this.allProfiles = (await getAllProfiles()).data.data.map((profile) => {
				return {
					profileName: profile.profileName,
					_id: profile._id,
					primary: profile.primary,
				};
			});
		},
	},
};
</script>

<style>
.width96px {
	width: 96px;
}
/* rename */
.radioformgrp .form-group {
	margin-bottom: 0;
}
.rpro-flex-1 {
	display: flex;
	align-items: flex-start;
}

.rpro-justify-cont {
	justify-content: flex-end;
}
.rpro-border-top {
	border-top: 1px solid #ffffff;
}
.rpro-w95 {
	width: 95%;
}
#renamemodal1 .modal-body {
	padding: 0;
}
@media (max-width: 1028px) {
	.rpro-flex-1 {
		flex-direction: column;
		align-items: center;
	}
	.rpro-text {
		padding-left: 0 !important;
		margin-top: 15px;
	}
	.rpro-txt-center {
		text-align: center;
		width: 100%;
	}
	.rpro-justify-cont {
		justify-content: center;
	}
	.rpro-border-top {
		border-top: 1px solid #d9d9d9;
	}

	.rpro-40 {
		width: 45%;
	}
	.rpro-100 {
		width: 100%;
	}
	.rpro-svg-size {
		height: 50px;
	}
	.rpro-w95 {
		width: 100%;
	}
	.mob-w50 {
		width: 50%;
	}
}
</style>
